import PropTypes from 'prop-types'
import Lottie from 'react-lottie'
import * as animationData from './data.json'

const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData: animationData.default,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
}

const Login = ({ width, height }) => {
  return (
    <Lottie
      options={defaultOptions}
      isClickToPauseDisabled
      width={width}
      height={height}
    />
  )
}

Login.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
}

export default Login
